export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'LOCATION_MESSAGE_SET':
      return payload
    case 'LOGOUT':
      return state
    // return []
    default:
      return state
  }
}
